/**
 * Extended ViewController template
 *
 * User: adic
 * Date: 2/5/13
 * Time: 1:37 PM
 */
define(function (require) {

    window.lpTag = window.lpTag || {};

    var TableViewController = require('web-agent-framework/TableViewController');
    var ViewController = require('web-agent-framework/ViewController');

    var ShortcutPopupViewController = ViewController.extend({
        ControllerName: 'ShortcutPopupViewController',

        LPViewMap: {
            tablePlaceholder: ".lpview_hotkeys_table",
            mainElement: ".lpview_hotkeys",
            closeShortcutPopDialog: ".lpview_close_button"
        },

        initialize: function (constructorData) {
            this.tableContext = constructorData.context || this;
            this.dataBinder = constructorData.dataBinder;

            this.shortcutsTable = new TableViewController({
                rowTemplateFile: "LP_hotkey_item.html",
                noDataTemplate: "LP_recommended_content_no_data.html",
                dataRenderer: this.dataRenderer,
                dataBinder: this.dataBinder,
                modelData: constructorData.modelData,
                context: this.tableContext,
                supportKeysNavigation: true
            });


            this.addViewController({viewController: this.shortcutsTable, target: this.LPViewMap.tablePlaceholder});
        },

        events: function () {
            this.bindViewEvent({selector : this.LPViewMap.closeShortcutPopDialog, DOMEvent : "click", callback : this.shortcutsTable.dataBinder.operationCanceled, context: this.tableContext});
        },

        render: function () {
        }
    });

    ShortcutPopupViewController.prototype.updateModelData = function (data) {
        this.shortcutsTable.updateModelData(data);
    };

    ShortcutPopupViewController.prototype.dataRenderer = {
        numberOfSections: function (data) {
            return data.length; // If the data is array, if no sections available, return 1
        },
        numberOfRowsInSection: function (data, sectionIndex) {
            return data[sectionIndex].length; // For array of arrays.
        },
        dataForSection: function (data, sectionIndex) {
            // The data will be injected to the section template.
        },
        dataForRowInSection: function (data, rowIndex, sectionIndex) {
            var dataObj = data[sectionIndex][rowIndex];
            var value = {};
            if (dataObj) {
                value.action = dataObj.type;
                value.hotkey = dataObj.hotkey;
                value.description = dataObj.tooltip || dataObj.type;
                value.rowData = dataObj;
                return value;
            } else {
                return null; // this is an empty place in the array, don't create a row for it.
            }
        }
    };

    ShortcutPopupViewController.prototype.lpShow = function (view, parentScope, animate) {
        view = view || this.view;
        ViewController.prototype.lpShow.call(this, view, parentScope, animate);
        if (view === this.view) {
            this.shortcutsTable.lpShow();
            this.shortcutsTable.focus();
        }
    };

    ShortcutPopupViewController.prototype.lpHide = function (view, parentScope, animate) {
        view = view || this.view;
        ViewController.prototype.lpHide.call(this, view, parentScope, animate);
        if (view === this.view) {
            this.shortcutsTable.lpHide();
            this.shortcutsTable.blur();
        }
    };

    ShortcutPopupViewController.prototype.updateFocusedView = function (focusedView) {
        if (this.shortcutsTable.focusedView !== focusedView) {
            this.shortcutsTable.updateFocusedView(focusedView);
        }
        this.shortcutsTable.focus();
    };

    return ShortcutPopupViewController;

});
